import { safeUrl, validateEmailHtml } from './contracts';

const parse = html => new DOMParser().parseFromString(html, 'text/html');
const serialize = doc => '<!DOCTYPE html>\n' + doc.documentElement.outerHTML;
function pathFor(node, root) {
  const path = [];
  while (node !== root) {
    path.unshift(Array.prototype.indexOf.call(node.parentNode.childNodes, node));
    node = node.parentNode;
  }
  return path;
}

export function htmlDesignFields(html) {
  const doc = parse(html);
  const fields = [];
  const walk = node => {
    if (node.nodeType === 3 && node.textContent.trim()) {
      fields.push({ kind: 'text', label: 'Text', value: node.textContent, path: pathFor(node, doc.body) });
    } else if (node.nodeType === 1) {
      if (['STYLE', 'SCRIPT', 'NOSCRIPT', 'TEMPLATE', 'SVG'].includes(node.tagName)) return;
      if (node.tagName === 'IMG') {
        fields.push({ kind: 'src', label: 'Image URL', value: node.getAttribute('src') || '', path: pathFor(node, doc.body) });
        fields.push({ kind: 'alt', label: 'Image description', value: node.getAttribute('alt') || '', path: pathFor(node, doc.body) });
      }
      if (node.tagName === 'A' && node.hasAttribute('href'))
        fields.push({ kind: 'href', label: node.hasAttribute('data-groove-needs-link') ? 'Website link required' : 'Link URL', value: node.getAttribute('href'), path: pathFor(node, doc.body) });
      Array.from(node.childNodes).forEach(walk);
    }
  };
  walk(doc.body);
  return fields.map((field, index) => ({ ...field, id: index }));
}

export function updateHtmlDesign(html, field, value) {
  if (['href', 'src'].includes(field.kind) && value && !safeUrl(value))
    throw new Error('Use an HTTP, HTTPS, email, telephone or merge-variable link.');
  const doc = parse(html);
  const node = field.path.reduce((parent, index) => parent && parent.childNodes[index], doc.body);
  if (!node) throw new Error('The design changed. Choose the content again.');
  if (field.kind === 'text') node.textContent = value;
  else if (['src', 'alt', 'href'].includes(field.kind)) {
    const old = node.getAttribute(field.kind);
    node.setAttribute(field.kind, value);
    if (field.kind === 'href' && value && value !== '#') node.removeAttribute('data-groove-needs-link');
    // Outlook VML fallbacks live in conditional comments; keep their links/images in sync.
    if (old && ['src', 'href'].includes(field.kind)) {
      const escaped = value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');
      const container = node.closest('td,th') || node.closest('p,div,li') || node.parentNode;
      const walker = doc.createTreeWalker(container, 1 | 128);
      let matchingComment = null;
      let reachedNode = false;
      while (walker.nextNode()) {
        const comment = walker.currentNode;
        if (comment === node) {
          reachedNode = true;
          if (matchingComment) break;
        } else if (comment.nodeType === 1 && comment.getAttribute(field.kind) === old) {
          // Another button/image owns the preceding fallback; never alter it.
          if (reachedNode) break;
          matchingComment = null;
        } else if (comment.nodeType === 8 && /\[if\b/i.test(comment.nodeValue) && comment.nodeValue.includes(`${field.kind}="${old}"`)) {
          matchingComment = comment;
          if (reachedNode) break;
        }
      }
      if (matchingComment) matchingComment.nodeValue = matchingComment.nodeValue.split(`${field.kind}="${old}"`).join(`${field.kind}="${escaped}"`);
    }
  }
  const result = serialize(doc);
  validateEmailHtml(result);
  return result;
}
